const productGridForm = () => {
  const variants = (productId) => {
    const data = JSON.parse(document.getElementById(`ProductJson${productId}`).innerHTML);

    const selectCallback = (variant) => {
      const that = document.querySelector(`.js-product-grid-item[data-product-id='${productId}']`);

      if (variant) {
        const priceOldElement = that.querySelector(".js-price-old");
        const priceNewElement = that.querySelector(".js-price-new");

        if (variant.compare_at_price > variant.price) {
          if (priceOldElement) {
            priceOldElement.classList.remove("d-none");
            priceOldElement.innerHTML = Shopify.formatMoney(variant.compare_at_price);
          }
          if (priceNewElement) {
            priceNewElement.classList.remove("d-none");
            priceNewElement.innerHTML = Shopify.formatMoney(variant.price);
          }
          priceNewElement.classList.add("price-new");
        } else {
          if (priceOldElement) priceOldElement.classList.add("d-none");
          if (priceNewElement) priceNewElement.classList.remove("d-none");
          priceNewElement.innerHTML = Shopify.formatMoney(variant.price);
          priceNewElement.classList.remove("price-new");
        }

        that.querySelectorAll('.js-product-size-1, .js-product-size-2, .js-product-size-3').forEach(sizeElement => {
          const value = sizeElement.getAttribute('data-value');
          const option = sizeElement.getAttribute('data-option');
          const parentSizes = sizeElement.closest('.js-product-grid-item-sizes');
          const dataIndex = parentSizes?.getAttribute('data-index') || "1";

          let soldOut = true;

          if (dataIndex === "1") {
            document.querySelectorAll(`.js-product-grid-item[data-product-id='${productId}'] select[name='id'] option`).forEach(optionEl => {
              const option1 = optionEl.getAttribute('data-option-1');
              const option2 = optionEl.getAttribute('data-option-2');
              const option3 = optionEl.getAttribute('data-option-3');

              const optionMatches = option1 === value || option2 === value || option3 === value;

              if (optionMatches && !optionEl.disabled && !optionEl.hasAttribute('disabled')) {
                soldOut = false;
              }
            });
          } else {
            const selectedOptions = {};
            that.querySelectorAll(`.js-product-grid-item[data-product-id='${productId}'] .selector-wrapper select`).forEach(select => {
              const optionName = select.getAttribute('data-option');
              if (optionName !== option) {
                selectedOptions[optionName] = select.value;
              }
            });

            document.querySelectorAll(`.js-product-grid-item[data-product-id='${productId}'] select[name='id'] option`).forEach(optionEl => {
              const option1 = optionEl.getAttribute('data-option-1');
              const option2 = optionEl.getAttribute('data-option-2');
              const option3 = optionEl.getAttribute('data-option-3');

              const matchesSelectedOptions =
                (!selectedOptions['option1'] || option1 === selectedOptions['option1']) &&
                (!selectedOptions['option2'] || option2 === selectedOptions['option2']) &&
                (!selectedOptions['option3'] || option3 === selectedOptions['option3']);

              if (matchesSelectedOptions && (option1 === value || option2 === value || option3 === value)) {
                if (!optionEl.disabled && !optionEl.hasAttribute('disabled')) {
                  soldOut = false;
                }
              }
            });
          }

          if (soldOut) {
            sizeElement.classList.add('out-of-stock');
          } else {
            sizeElement.classList.remove('out-of-stock');
          }
        });

        if (variant.featured_media) {
          const images = that.querySelectorAll(".js-variant-image");

          images.forEach(image => image.classList.add('d-none'));

          const targetIndex = variant.featured_media.position ;
          const targetImage = that.querySelector(`[data-index="${targetIndex}"]`);

          if (targetImage) {
            targetImage.classList.remove('d-none');
          }

          that.querySelectorAll('.js-add-to-cart').forEach(button => {
            button.setAttribute('data-featured-image', variant.featured_media.preview_image.src + '&width=300');
          });
        }
      }
    };

    if (document.getElementById(`product-select-${productId}`)) {
      new Shopify.OptionSelectors(`product-select-${productId}`, {
        product: data,
        onVariantSelected: selectCallback,
        enableHistoryState: false
      });
    }
  };

  document.querySelectorAll(".js-product-grid-item:not(.active)").forEach((element) => {
    const productId = element.getAttribute("data-product-id");
    const json = document.getElementById(`ProductJson${productId}`);
    
    element.addEventListener('touchstart', function () {
      document.querySelectorAll('.js-product-grid-item').forEach(function (el) {
        el.classList.remove('hover');
      });
      element.classList.add('hover');
    });

    if (json) {
      variants(productId);

      ['.js-product-size-1', '.js-product-size-2', '.js-product-size-3'].forEach(selector => {
        element.querySelectorAll(selector).forEach(sizeElement => {
          sizeElement.addEventListener('click', function () {
            const value = this.getAttribute('data-value');
            const option = this.getAttribute('data-option');

            element.querySelectorAll(selector).forEach(el => el.classList.remove('active'));

            this.classList.add('active');

            const productVariants = document.querySelector(`.js-product-grid-item[data-product-id='${productId}'] select[data-option='${option}']`);
            if (productVariants) {
              productVariants.value = value;
              productVariants.dispatchEvent(new Event('change'));
            }
          });
        });
      });

      ['.js-product-size-1', '.js-product-size-2', '.js-product-size-3'].forEach((selector, index) => {
        element.querySelectorAll(selector).forEach(sizeElement => {
          sizeElement.addEventListener('click', function () {
            if (this.classList.contains('out-of-stock')) return;

            const productItem = this.closest('.js-product-grid-item');
            const hoverElement = productItem.querySelector('.js-product-grid-item-hover');
            const nextIndex = index + 2;

            const nextStep = productItem.querySelector(`.js-product-grid-item-sizes[data-index='${nextIndex}']`);
            const optionName = nextStep?.getAttribute('data-option-name');

            if (nextStep && optionName !== 'Color' && optionName !== 'Colour') {
              hoverElement.classList.add(`step-${nextIndex}`);
            } else {
              const addToCartBtn = productItem.querySelector('.js-add-to-cart');
              if (addToCartBtn) {
                addToCartBtn.click();
              }
            }
          });
        });
      });
    }

    element.classList.add("active");
  });

  document.querySelectorAll('.js-open-mobile-options').forEach(button => {
    button.addEventListener('click', function () {
      const item = this.closest('.js-product-grid-item');
      if (item) {
        document.querySelectorAll('.js-product-grid-item.display, .js-product-grid-item.show, .js-product-grid-item.deactivate')
          .forEach(el => {
            el.classList.remove('display', 'show', 'deactivate');
          });

        item.classList.add("display");
        item.classList.remove("deactivate");

        document.querySelectorAll('[data-aos="fade-up"]').forEach(el => {
          el.removeAttribute('data-aos');
        });

        setTimeout(() => {
          item.classList.add("show");
        }, 50);
      }
    });
  });

  document.querySelectorAll('.js-close-mobile-options').forEach(button => {
    button.addEventListener('click', function () {
      const item = this.closest('.js-product-grid-item');
      if (item) {
        item.classList.add("deactivate");

        setTimeout(() => {
          item.classList.remove("show", "display", "deactivate");
        }, 300);
      }
    });
  });
};

document.addEventListener('DOMContentLoaded', () => {
  productGridForm();
});